<template>
  <!-- HERO -->
  <section class="py-16 md:py-24">
    <div class="max-w-page mx-auto px-6">
      <div class="max-w-3xl">
        <span class="inline-block rounded-badge bg-white border border-stone text-primary text-xs font-medium tracking-label uppercase px-3 py-1">
          Hakkımızda
        </span>
        <h1 class="mt-6 text-4xl md:text-5xl lg:text-6xl font-medium text-primary tracking-display leading-[0.95]">
          Gayrimenkul yatırımının<br />kurallarını yeniden yazıyoruz.
        </h1>
        <p class="mt-6 text-graphite text-base md:text-lg leading-relaxed">
          Bloqin, blokzincir teknolojisi ile gerçek dünya varlıklarını tokenize ederek erişilebilir,
          şeffaf ve likit yatırımlar sunmak için kurulmuş bir teknoloji girişimidir.
        </p>
      </div>
    </div>
  </section>

  <!-- COMPANY — ERV Teknoloji A.Ş. -->
  <section class="py-12 md:py-16">
    <div class="max-w-page mx-auto px-6">
      <div class="rounded-card magicpattern text-white p-8 md:p-12 lg:p-16">
        <div class="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-12 items-start">
          <div class="md:col-span-5">
            <span class="inline-block rounded-badge bg-secondary text-primary text-xs font-medium tracking-label uppercase px-3 py-1">
              Tüzel Kişilik
            </span>
            <h2 class="mt-4 text-3xl md:text-4xl lg:text-5xl font-medium leading-[0.95] tracking-display">
              ERV Teknoloji A.Ş.
            </h2>
          </div>
          <div class="md:col-span-7 space-y-4 text-stone text-base md:text-lg leading-relaxed">
            <p>
              Bloqin,
              <span class="text-secondary font-medium">ERV Teknoloji Anonim Şirketi</span>
              bünyesinde geliştirilen bir girişimdir. ERV, blokzincir teknolojisi ve gerçek dünya
              varlıkları (RWA) alanında çalışan, regülasyon-uyumlu finansal teknoloji çözümleri üreten
              bir teknoloji şirketidir.
            </p>
            <p>
              Şirketimiz,
              <a href="https://equityroadventures.com" target="_blank" class="underline decoration-secondary decoration-2 underline-offset-4 text-secondary">Equity Road Ventures</a>
              portföyünde yer alır; deneyimli bir girişim sermayesi şirketinin desteğiyle
              uzun vadeli, sürdürülebilir bir vizyonla yola çıkmıştır.
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- MISSION -->
  <section class="py-16 md:py-20">
    <div class="max-w-page mx-auto px-6">
      <div class="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-12 items-start">
        <div class="md:col-span-5">
          <p class="text-xs font-medium tracking-label uppercase text-graphite">Misyonumuz</p>
          <h2 class="mt-4 text-4xl md:text-5xl font-medium text-primary tracking-display leading-[0.95]">
            Yatırımı herkes için erişilebilir kılmak.
          </h2>
        </div>
        <div class="md:col-span-7 space-y-5 text-graphite text-base md:text-lg leading-relaxed">
          <p>
            Geleneksel gayrimenkul yatırımı, yüksek minimum sermaye, karmaşık evrak ve aylar süren
            likidite süreciyle çoğu yatırımcının erişiminin dışında kaldı.
          </p>
          <p>
            <span class="text-primary font-medium">Bloqin</span> ile bu dengeyi değiştiriyoruz.
            Düşük bütçeyle başlayan bir yatırımcının milyonluk gayrimenkullere parça parça
            ortak olabildiği; kira gelirinden payını otomatik aldığı; istediği zaman likit
            edebileceği bir finansal sistem inşa ediyoruz.
          </p>
          <p>
            Hedefimiz, blokzincir teknolojisinin sunduğu şeffaflık ve verimliliği,
            <span class="text-primary font-medium">regülasyon-uyumlu</span> bir çerçeveyle
            geleneksel finansla buluşturmak.
          </p>
        </div>
      </div>
    </div>
  </section>

  <!-- VALUES -->
  <section class="py-16 md:py-20">
    <div class="max-w-page mx-auto px-6">
      <div class="max-w-3xl mb-12">
        <p class="text-xs font-medium tracking-label uppercase text-graphite">Değerlerimiz</p>
        <h2 class="mt-4 text-4xl md:text-5xl font-medium text-primary tracking-display leading-[0.95]">
          Dört temel ilke.
        </h2>
      </div>

      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
        <div class="rounded-card bg-white border border-stone p-6 md:p-7">
          <span class="w-10 h-10 rounded-full bg-secondary flex items-center justify-center text-primary">
            <svg class="w-5 h-5" fill="none" stroke="currentColor" stroke-width="1.8" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/><path stroke-linecap="round" stroke-linejoin="round" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"/></svg>
          </span>
          <h3 class="mt-5 text-lg font-medium text-primary leading-tight">Şeffaflık</h3>
          <p class="mt-2 text-sm text-graphite leading-relaxed">
            Her işlem blokzincirde kalıcı kayıt altında. Saklı maliyet, gizli komisyon yok.
          </p>
        </div>

        <div class="rounded-card bg-parchment border border-stone p-6 md:p-7">
          <span class="w-10 h-10 rounded-full bg-secondary flex items-center justify-center text-primary">
            <svg class="w-5 h-5" fill="none" stroke="currentColor" stroke-width="1.8" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"/></svg>
          </span>
          <h3 class="mt-5 text-lg font-medium text-primary leading-tight">Erişilebilirlik</h3>
          <p class="mt-2 text-sm text-graphite leading-relaxed">
            Düşük giriş bariyeri. Sermayenin küçük ya da büyük olması fark etmez.
          </p>
        </div>

        <div class="rounded-card magicpattern text-white p-6 md:p-7">
          <span class="w-10 h-10 rounded-full bg-secondary flex items-center justify-center text-primary">
            <svg class="w-5 h-5" fill="none" stroke="currentColor" stroke-width="1.8" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"/></svg>
          </span>
          <h3 class="mt-5 text-lg font-medium leading-tight">Güven</h3>
          <p class="mt-2 text-sm text-stone/80 leading-relaxed">
            ERC-3643 standardı, KYC/AML uyumluluğu, bağımsız smart kontrat denetimleri.
          </p>
        </div>

        <div class="rounded-card bg-secondary text-primary p-6 md:p-7">
          <span class="w-10 h-10 rounded-full bg-primary flex items-center justify-center text-secondary">
            <svg class="w-5 h-5" fill="none" stroke="currentColor" stroke-width="1.8" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" d="M13 10V3L4 14h7v7l9-11h-7z"/></svg>
          </span>
          <h3 class="mt-5 text-lg font-medium leading-tight">Yenilik</h3>
          <p class="mt-2 text-sm leading-relaxed">
            Geleneksel finansın limitlerini blokzincirle aşıyoruz. Hız, likidite, otomasyon.
          </p>
        </div>
      </div>
    </div>
  </section>

  <!-- CTA — Apply -->
  <section class="py-16 md:py-24">
    <div class="max-w-page mx-auto px-6">
      <div class="rounded-card bg-secondary p-8 md:p-12 lg:p-16 text-center">
        <span class="inline-block rounded-badge bg-primary text-secondary text-xs font-medium tracking-label uppercase px-3 py-1">
          Birlikte Çalışalım
        </span>
        <h2 class="mt-6 text-3xl md:text-4xl lg:text-5xl font-medium text-primary leading-[0.95] tracking-display">
          Bloqin yolculuğunda yer al.
        </h2>
        <p class="mt-5 text-primary text-base md:text-lg leading-relaxed max-w-2xl mx-auto">
          Advisory board üyeliği, stratejik ortaklık, gayrimenkul sponsorluğu veya farklı bir
          rolle katkı sağlamak istiyorsan başvuru sayfamızı incele.
        </p>
        <router-link
          to="/apply#apply"
          class="mt-8 inline-flex items-center px-6 py-4 rounded-btn border border-primary bg-primary text-secondary text-base font-medium hover:bg-cream hover:text-primary transition-colors"
        >
          Başvuru formunu aç
          <span aria-hidden="true" class="ml-2">→</span>
        </router-link>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'AboutView',
});
</script>
